
export function InvalidRegionException(message) {
    this.message = message;
}

InvalidRegionException.prototype = Object.create(Error.prototype);


// WEBPACK FOOTER //
// ./src/errors/InvalidRegionException.js